export const deliveryTypes = {
  SET_DELIVERY_ADDRESS: 'SET_DELIVERY_ADDRESS',
  SET_ITEM_DETAILS: 'SET_ITEM_DETAILS',
  SET_ENABLE_DATES_TIMES_FORM: 'SET_ENABLE_DATES_TIMES_FORM',
  SET_DELIVERY_DATES_TIMES: 'SET_DELIVERY_DATES_TIMES',
  RESET_DATES_TIMES: 'RESET_DATES_TIMES',
  SET_ACTIVE_SECTION: 'SET_ACTIVE_SECTION'
};
